import { type ReactNode } from 'react';

import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';
import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import AddOnIcon, { type AddOnIconProps } from 'components/AddOnIcon';

export const AddonCardSkeleton = () => {
	return (
		<Stack
			sx={{
				justifyContent: 'center',
				gap: 100,
			}}
		>
			<Skeleton
				variant="rounded"
				sx={{ width: '200px', height: ({ size }) => size.xS }}
			/>
			<Stack direction="row" sx={{ gap: 100 }}>
				<Skeleton
					variant="rounded"
					sx={{ width: '80px', height: ({ size }) => size.xS }}
				/>
				<Skeleton
					variant="rounded"
					sx={{ width: '80px', height: ({ size }) => size.xS }}
				/>
			</Stack>
		</Stack>
	);
};

export interface AddonCardProps {
	title: ReactNode;
	loading?: boolean;
	info?: ReactNode;
	infoContainerProps?: StackProps;
	addOnType: AddOnIconProps['type'];
}

const AddonCard = ({
	title,
	loading,
	info,
	infoContainerProps,
	addOnType,
}: AddonCardProps) => {
	return (
		<Stack
			direction="row"
			sx={{
				gap: 200,
			}}
		>
			<Stack
				sx={{
					alignItems: 'flex-start',
				}}
			>
				<AddOnIcon type={addOnType} size="medium" />
			</Stack>
			{loading ? (
				<AddonCardSkeleton />
			) : (
				<Stack
					sx={{
						justifyContent: 'center',
						gap: 50,
					}}
				>
					<Typography
						variant="title-xs"
						sx={{
							fontWeight: 500,
						}}
					>
						{title}
					</Typography>
					{info && <Stack {...infoContainerProps}>{info}</Stack>}
				</Stack>
			)}
		</Stack>
	);
};

export default AddonCard;
